<!--<div id="overlay">-->
<!--  <ap-loading *ngIf="startLoader" id="text" class="loader-class" [colorName]="'a-primary'">-->
<!--  </ap-loading>-->
<!--</div>-->
@if (startLoader) {
  <div class="loader-overlay">
    <div class="backdrop"></div>
    <ap-loading class="loader" [loadingType]="'circular'" [indeterminate]="true" [compact]="false"></ap-loading>
  </div>
}
<dst-create-disclosure-actions [isView]="false" (onSaveClick)="save()" [disabled]="false" [displayNotification]="showDREMsg" [notifMsg]="DREMsg"
  (onCancelClick)="clear()">
</dst-create-disclosure-actions>
<div class="form-template-wrapper" [ngClass]="showDREMsg ? 'msg-expanded' : ''">
  <div [formGroup]="form188">
    <dst-template-header [parentFormGroup]="form188" [overwriteFormName]="'STATEMENT PURSUANT TO REGULATION 1.368-3'"
      [allowOptional]="true"
      [extraLine]="'BY A CORPORATION A PARTY TO A REORGANIZATION AND BY A SIGNIFICANT SHAREHOLDER'"
      [dropDownOptions]="headerOptions" (formOptionChanged)="onFormOptionChanged($event)"
      (consolGroupChanged)="OnConsolGroupChanged($event)">
    </dst-template-header>
    <div formGroupName="main">
      Pursuant to Section 1.368-3{{headerOptionVal}} of the Regulations, the following information is furnished:
      <dst-template-leid-selector class="required-field entity-leid-label" #mainLeidSelector
        [label]="'Please specify the LEID of the Target Corporation'" [labelId]="'100'"
        (onSelectedLEChanged)="onTargetChanged($event)">
      </dst-template-leid-selector>
      <!-- <div class="a-form-error error-leid" *ngIf="target === undefined">
      Please specify the Target
    </div> -->
    <div class="entity-details">
      <span class="ed-label">The following: <strong>Target Corporation</strong> </span><span class="template-color-blue">{{!target ? ''
    : target.ENTITY}}</span>
  </div>
  <div class="entity-details">
    <span class="ed-label">EIN:</span><span class="template-color-blue">{{!target ? '' : (target.EIN ? target.EIN : 'N/A')}}</span><span>,&nbsp; a&nbsp;
  </span><span class="template-color-blue"> {{!target ? '' : target?.COUNTRYINC +
(target | taxtype: target?.TAXTYPECODE: entityNameChangeOnDate)}}</span>
</div>
<dst-template-leid-selector class="required-field entity-leid-label" #mainLeidSelector
  [label]="'Please specify the LEID of Acquiring'" [labelId]="'100'"
  (onSelectedLEChanged)="onAcquirerChanged($event)">
</dst-template-leid-selector>
<!-- <div class="a-form-error error-leid" *ngIf="acquirer === undefined">
Please specify the Acquirer
</div> -->
<div class="entity-details">
  <span class="ed-label">The following: <strong>Acquirer</strong> </span><span class="template-color-blue">{{!acquirer ? '' :
acquirer.ENTITY}}</span>
</div>
<div class="entity-details">
  <span class="ed-label">EIN:</span><span class="template-color-blue">{{!acquirer ? '' : (acquirer.EIN ? acquirer.EIN : 'N/A')}}</span><span>,&nbsp; a
&nbsp; </span><span class="template-color-blue"> {{!acquirer ? '' : acquirer?.COUNTRYINC +
(acquirer | taxtype: acquirer?.TAXTYPECODE: entityNameChangeOnDate)}}</span>
</div>
<dst-template-leid-selector class="entity-leid-label" #mainLeidSelector [label]="'Please specify the LEID of the Significant Holder'"
  [labelId]="'100'" (onSelectedLEChanged)="onSHolderChanged($event)">
</dst-template-leid-selector>
<div class="entity-details">
  <span class="ed-label">The following: <strong>Significant Holder</strong> </span><span class="template-color-blue">{{!sHolder ?
'' : sHolder.ENTITY}}</span>
</div>
<div class="entity-details">
  <span class="ed-label">EIN:</span><span class="template-color-blue">{{!sHolder ? '' : (sHolder.EIN ? sHolder.EIN : 'N/A')}}</span><span>,&nbsp; a &nbsp;
</span><span class="template-color-blue"> {{!sHolder ? '' : sHolder?.COUNTRYINC +
(sHolder | taxtype: sHolder?.TAXTYPECODE: entityNameChangeOnDate)}}</span>
</div>

<ap-field [title]="''" [fieldId]="'1'" [hideTitleOnInput]="true">
                    <textarea appkit-field [(ngModel)]="Para1" [ngModelOptions]="{standalone: true}" aria-label="1"></textarea>
</ap-field>
<div class="d-flex">
  <span class="inline-para-text">are parties in a transaction that qualified as a reorganization under Code Section
  &nbsp;</span>
  <ap-dropdown [list]="codeSectionDropdown" [selectType]="'single'"
    class="inline-dropdown show-label select-dropdown field-full-width"
    [title]="'** Please select a code section **'" [inputAriaLabel]="'** Please select a code section **'" [optionName]="'text'"
    (onSelect)="codeSelected($event)" [hideTitleOnInput]="true"
    [(ngModel)]="selectedCodeItem" [ngModelOptions]="{standalone: true}">
    @for (item of codeSectionDropdown; track item) {
      <ap-dropdown-list-item #dropdownListItem [item]="item"
        [optionName]="'text'"
        [ariaLabel]="setAriaLabel(item, '** Please select a code section **')"
      (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
    }
  </ap-dropdown>

</div>
<!-- <div class="a-form-error error-dropdown" *ngIf="selectedCode === -1">
Please select a code section
</div> -->
<ol start="2" style="margin: 15px;">
  <li>
    <div style="display: grid;">
      <div class="col-md-6 pl-0">
        The date of the reorganization was
      </div>
      <div class="col-md-5 pl-0 d-flex">
        @if (showDate.liqDate1 && nameChangeChecked) {
          <app-date-picker-with-clear

            [minDate]="beginDate"
            [maxDate]="endDate"
            [datePickerClass]="'required-field'"
            [required]="true"
            (dateChange)="dateChange($event, 1)"
            (datePickerClick)="onDPOpen()"
            (clearClick)="clearDate(1)"
            [(ngModel)]="LiquidationDate1"
            [ngModelOptions]="{standalone: true}">
          </app-date-picker-with-clear>
        }
        <!-- <div class="a-form-error" *ngIf="LiquidationDate1 === null || LiquidationDate1 === ''">
        Please select Date of reorganization
      </div> -->
    </div>


  </div>

</li>

<!-- <u>Disclosure required for Target/Corporation:</u>&nbsp; -->
<li>
  The value and basis of the assets, stock or securities
  of the target corporation transferred in the transaction, determined immediately before the transfer and
  aggregated as follows:
  <ol class="inner-list">
    <li>
      <div class="list-content a-textarea-box a-field-length-validation">
        <span class="a-form-label d-inline-block textarea-label" style="font-size: inherit;">Importation property transferred in a loss importation transaction, as defined in Section 1.362-3(c)(2) and (3), respectively:</span>
        <ap-field [fieldId]="'310'" [styleClass]="'text-box'">
                    <textarea appkit-field maxlength="1000" [(ngModel)]="importationPropertyDesc" [ngModelOptions]="{standalone: true}" aria-label="310"></textarea>
          <ap-field-counter [max]="1000" [value]="importationPropertyDesc"></ap-field-counter>
        </ap-field>
      </div>
    </li>
    <li>
      <div class="list-content a-textarea-box a-field-length-validation">
        <span class="a-form-label d-inline-block textarea-label" style="font-size: inherit;">Loss duplication property as defined in Section 1.362-4(g)(1):</span>
        <ap-field [fieldId]="'320'" [styleClass]="'text-box'">
                    <textarea appkit-field maxlength="1000" [(ngModel)]="lossDuplicationPropertyDesc" [ngModelOptions]="{standalone: true}" aria-label="320"></textarea>
          <ap-field-counter [max]="1000" [value]="lossDuplicationPropertyDesc"></ap-field-counter>
        </ap-field>
      </div>
    </li>
    <li>
      <div class="list-content a-textarea-box a-field-length-validation">
        <span class="a-form-label d-inline-block textarea-label" style="font-size: inherit;">Property with respect to which any gain or loss was recognized on the transfer (without regard to whether such property is also identified in paragraph (a)(3)(i) or (ii) of this section)</span>
        <ap-field [fieldId]="'330'" [styleClass]="'text-box'">
                    <textarea appkit-field maxlength="1000" [(ngModel)]="gainLossPropertyDesc" [ngModelOptions]="{standalone: true}" aria-label="330"></textarea>
          <ap-field-counter [max]="1000" [value]="gainLossPropertyDesc"></ap-field-counter>
        </ap-field>
      </div>
    </li>
    <li>
      <div class="list-content">
        <span class="a-form-label d-inline-block" style="cursor: default; font-size: inherit;">Property not described in paragraph (a)(3)(i), (ii), or (iii) of this section;</span>

        <table class="table-layout">
          <tbody>
            <tr>
              <td colspan="3">
                @if (showImport) {
                  <ap-button [compact]="true" [btnType]="'primary'" [label]="'Import Domestic or Foreign Trial Balance Data'"
                    class="import-btn ap-mr-spacing-3" (onClick)="import()" [disabled]="!LiquidationDate1">
                  </ap-button>
                }
                @if (showTotal) {
                  <ap-checkbox [styleClass]="'a-mx-10 import-btn'"
                    (onChange)="total($event)">
                    <span>Report TB Data on Total Net Assets basis</span>
                  </ap-checkbox>
                }
              </td>
              <td>
                <ap-dropdown [list]="propertyValBasisOptions" [selectType]="'single'"
                  class="show-label field-full-width" [title]="'** Select a basis **'" [inputAriaLabel]="'** Select a basis **'"
                  [optionName]="'text'"
                  (onSelect)="selectBasisOption($event)" [hideTitleOnInput]="true"
                  [(ngModel)]="selectedBasisItem" [ngModelOptions]="{standalone: true}">
                  @for (item of propertyValBasisOptions; track item) {
                    <ap-dropdown-list-item #dropdownListItem [item]="item"
                      [optionName]="'text'"
                      [ariaLabel]="setAriaLabel(item, '** Select a basis **')"
                    (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
                  }
                </ap-dropdown>
                <!-- <div class="a-form-error" *ngIf="selectedBasis === -1">
                Please select a Basis section
              </div> -->
            </td>
            <td></td>
          </tr>
          <tr>
            <td colspan="3"></td>
            <td><span>{{selectedBasisName}} Basis to the Transferor Corporation</span></td>
            <td><span>Fair Market Value on Date of Transfer</span></td>
          </tr>
          <tr>
            <td colspan="2"></td>
            <td class="header-column"><span>Description</span></td>
            <td>
              <ap-dropdown class="currency-dropdown field-full-width"
                [list]="currencyOptions" [selectType]="'single'" [showSearchbox]="true"
                [title]="'** Select Currency **'" [inputAriaLabel]="'** Select Currency **'" (onSelect)="currencyOneChange($event)" [hideTitleOnInput]="true" [(ngModel)]="selectedCurrencyItem" [ngModelOptions]="{standalone: true}">
                @for (item of currencyOptions; track $index) {
                  <ap-dropdown-list-item #dropdownListItem [item]="item"
                    [ariaLabel]="setAriaLabel(item, '** Select Currency **')"
                  (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
                }
              </ap-dropdown>
              <!-- <div class="a-form-error" *ngIf="selectedCurrency === 0">
              Please select Fair Market value Currency type
            </div> -->
          </td>
          <td>
            <ap-dropdown class="currency-dropdown field-full-width"
              [list]="currencyOptions2" [selectType]="'single'" [showSearchbox]="true"
              [title]="'** Select Currency **'" [inputAriaLabel]="'** Select Currency **'" (onSelect)="currencyTwoChange($event)" [hideTitleOnInput]="true" [(ngModel)]="selectedCurrencyItem2" [ngModelOptions]="{standalone: true}">
              @for (item of currencyOptions2; track $index) {
                <ap-dropdown-list-item #dropdownListItem [item]="item"
                  [ariaLabel]="setAriaLabel(item, '** Select Currency **')"
                (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
              }
            </ap-dropdown>
          </td>
        </tr>
        <ng-container formArrayName="additionalPropsDetails">
          @for (p of additionalPropsDetails.controls; track p; let i = $index) {
            <tr [formGroup]="$any(p)">
                <td style="width: 3%;">
                  @if (i > 0) {
                    <ap-button class="btn-plus-minus" [btnType]="'secondary'" [compact]="true"
                      [icon]="'minus-outline'" [add]="true"
                      (onClick)="removeAdditionalPropDetailsAt(i)">
                    </ap-button>
                  }
                </td>
                <td style="width: 3%;">
                  <ap-button class="btn-plus-minus" [btnType]="'secondary'" [compact]="true"
                    [icon]="'plus-outline'" [add]="true"
                    (onClick)="addAdditionalPropDetails()">
                  </ap-button>
                </td>
                <td style="width: 50%;">
                  <ap-field [title]="''" [fieldId]="'sec368-desc-' + i" [hideTitleOnInput]="true">
                    <input appkit-field formControlName="description" [attr.aria-label]="'Description ' + (i + 1)" />
                  </ap-field>
                </td>
                <td style="width: 22%;">
                  <ap-field [title]="''" [fieldId]="'sec368-basis-' + i" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field'"
                    [hideTitleOnInput]="true">
                    <input appkit-field onlyDigitsDecimal formControlName="transferorBasis" [attr.aria-label]="'Basis ' + (i + 1)"
                      (input)="onChangeNumber({value: $any($event.target).value}, i)" />
                    </ap-field>
                  </td>
                  <td style="width: 22%;">
                    <ap-field [title]="''" [fieldId]="'sec368-fmv-' + i" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field'"
                      [hideTitleOnInput]="true">
                    <input appkit-field onlyDigitsDecimal formControlName="fairMarketVal" [attr.aria-label]="'Fair market value ' + (i + 1)" />
                    </ap-field>
                  </td>
              </tr>
            }
          </ng-container>
        </tbody>
      </table>
    </div>

  </li>
</ol>
<p><u>Disclosure required for Significant Holder</u> (if applicable):</p>
<p>The value and basis of all the stock or securities of the target corporation held by the significant holder
  that is transferred in the transaction and such holder's basis in that stock or securities, determined
immediately before the transfer and aggregated as follows:</p>
<ol class="inner-list">
  <li>
    <div class="list-content a-textarea-box a-field-length-validation">
      <span class="a-form-label d-inline-block textarea-label" style="font-size: inherit;">Stocks and securities with respect to which an election is made under Section 362(e)(2)(C):</span>
      <ap-field [fieldId]="'340'" [styleClass]="'text-box'">
                    <textarea appkit-field maxlength="1000" [(ngModel)]="stocksSecurityPropertyDesc" [ngModelOptions]="{standalone: true}" aria-label="340"></textarea>
        <ap-field-counter [max]="1000" [value]="stocksSecurityPropertyDesc"></ap-field-counter>
      </ap-field>
    </div>
  </li>
  <li>
    <div class="list-content">
      <span class="a-form-label d-inline-block" style="cursor: default; font-size: inherit;">Stocks and securities not described
      in Section 1.368-3(b)(3)(i)::</span>

      <table class="table-layout">
        <tbody>
          <tr>
            <td colspan="3">
            </td>
            <td>
              @if (propertyValBasisOptions2.length > 1) {
                <ap-dropdown
                  [list]="propertyValBasisOptions2" [selectType]="'single'"
                  [showSearchbox]="true"
                  class="a-dropdown show-label field-full-width basis-dropdown"
                  [title]="'** Select a basis **'" [inputAriaLabel]="'** Select a basis **'"
                  [optionName]="'text'"
                  (onSelect)="selectBasisOption2($event)" [hideTitleOnInput]="true"
                  [(ngModel)]="selectedBasisItem2" [ngModelOptions]="{standalone: true}">
                  @for (item of propertyValBasisOptions2; track trackByDropdownValue($index, item)) {
                    <ap-dropdown-list-item #dropdownListItem
                      [item]="item"
                      [optionName]="'text'"
                      [ariaLabel]="setAriaLabel(item, '** Select a basis **')"
                    (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
                  }
                </ap-dropdown>
              }
              <!-- <div class="a-form-error" *ngIf="selectedBasis2 === -1">
              Please select a Basis section
            </div> -->
          </td>
          <td></td>
        </tr>
        <tr>
          <td colspan="3"></td>
          <td><span>{{selectedBasisName2}} Basis to the Significant Holder</span></td>
          <td><span>Fair Market Value on Date of Transfer</span></td>
        </tr>
        <tr>
          <td colspan="2"></td>
          <td class="header-column"><span>Description</span></td>
          <td>
            <ap-dropdown class="currency-dropdown field-full-width"
              [list]="currencyOptions3" [selectType]="'single'" [showSearchbox]="true"
              [title]="'** Select Currency **'" [inputAriaLabel]="'** Select Currency **'" (onSelect)="currencyOneChange2($event)" [hideTitleOnInput]="true" [(ngModel)]="selectedCurrencyItem3" [ngModelOptions]="{standalone: true}">
              @for (item of currencyOptions3; track $index) {
                <ap-dropdown-list-item #dropdownListItem [item]="item"
                  [ariaLabel]="setAriaLabel(item, '** Select Currency **')"
                (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
              }
            </ap-dropdown>
          </td>
          <td>
            <ap-dropdown class="currency-dropdown field-full-width"
              [list]="currencyOptions4" [selectType]="'single'" [showSearchbox]="true"
              [title]="'** Select Currency **'" [inputAriaLabel]="'** Select Currency **'" (onSelect)="currencyTwoChange2($event)" [hideTitleOnInput]="true" [(ngModel)]="selectedCurrencyItem4" [ngModelOptions]="{standalone: true}">
              @for (item of currencyOptions4; track $index) {
                <ap-dropdown-list-item #dropdownListItem [item]="item"
                  [ariaLabel]="setAriaLabel(item, '** Select Currency **')"
                (onSelectItem)="onDropdownSelectItem($event)"></ap-dropdown-list-item>
              }
            </ap-dropdown>
          </td>
        </tr>
        <ng-container formArrayName="additionalPropsDetails2">
          @for (p of additionalPropsDetails2.controls; track p; let i = $index) {
            <tr [formGroup]="$any(p)">
                <td style="width: 3%;">
                  @if (i > 0) {
                    <ap-button class="btn-plus-minus" [btnType]="'secondary'" [compact]="true"
                      [icon]="'minus-outline'" [add]="true"
                      (onClick)="removeAdditionalPropDetailsAt2(i)">
                    </ap-button>
                  }
                </td>
                <td style="width: 3%;">
                  <ap-button class="btn-plus-minus" [btnType]="'secondary'" [compact]="true"
                    [icon]="'plus-outline'" [add]="true"
                    (onClick)="addAdditionalPropDetails2()">
                  </ap-button>
                </td>
                <td style="width: 50%;">
                  <ap-field [title]="''" [fieldId]="'sec368-desc2-' + i" [hideTitleOnInput]="true">
                    <input appkit-field formControlName="description" [attr.aria-label]="'Significant holder description ' + (i + 1)" />
                  </ap-field>
                </td>
                <td style="width: 22%;">
                  <ap-field [title]="''" [fieldId]="'sec368-basis2-' + i" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field'"
                    [hideTitleOnInput]="true">
                    <input appkit-field onlyDigitsDecimal formControlName="transferorBasis" [attr.aria-label]="'Significant holder basis ' + (i + 1)"
                      (input)="onChangeNumber2({value: $any($event.target).value}, i)" />
                    </ap-field>
                  </td>
                  <td style="width: 22%;">
                    <ap-field [title]="''" [fieldId]="'sec368-fmv2-' + i" [type]="'appkit-number'" [format]="''" [styleClass]="'number-field'"
                      [hideTitleOnInput]="true">
                    <input appkit-field onlyDigitsDecimal formControlName="fairMarketVal" [attr.aria-label]="'Significant holder fair market value ' + (i + 1)" />
                    </ap-field>
                  </td>
              </tr>
            }
          </ng-container>
        </tbody>
      </table>
    </div>
  </li>
</ol>
</li>
<li>The date and control number of any private letter ruling(s) issued by the Internal Revenue Service in
  connection with this reorganization:
  <div id="step4">
    @if (showDate.liqDate2) {
      <app-date-picker-with-clear

        [minDate]="beginDate"
        [maxDate]="endDate"
        [datePickerClass]="''"
        [required]="false"
        (dateChange)="dateChange($event, 2)"
        (datePickerClick)="onDPOpen()"
        (clearClick)="clearDate(2)"
        [(ngModel)]="LiquidationDate2"
        [ngModelOptions]="{standalone: true}">
      </app-date-picker-with-clear>
    }
    <ap-field [fieldId]="'401'" [title]="''" [hideTitleOnInput]="true" [styleClass]="'plr-control-num-field'">
                    <input appkit-field [(ngModel)]="PLR" [ngModelOptions]="{standalone: true}"  aria-label="401" />
    </ap-field>
  </div>
</li>
</ol>
<div class="supp-info-wrapper">
  <div>Supplemental Information:</div>
  <ap-field [fieldId]="'550'" [title]="''" [hideTitleOnInput]="true">
                    <textarea appkit-field [(ngModel)]="section4text" [ngModelOptions]="{standalone: true}" aria-label="550"></textarea>
  </ap-field>
</div>
<div class="d-flex" style="margin-top: 15px;">
  <span>LEIDs: </span>
  <div>
    @if (target) {
      <span class="template-color-blue">{{ target.LEID }}</span>
      }@if (acquirer) {
      <span>
      / </span>
      }@if (acquirer) {
      <span class="template-color-blue">{{ acquirer.LEID }}</span>
      }@if (sHolder) {
      <span>
      / </span>
      }@if (sHolder) {
      <span class="template-color-blue">{{ sHolder.LEID }}</span>
    }
  </div>
</div>
</div>
</div>
</div>
